'use strict';

const initialState = {
};

function emptyReducer(state = initialState, action) {
    return state;
};

module.exports = {
    emptyReducer: emptyReducer
}